import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from '@/hooks/queries/query-keys';
import { isAlreadyChangedError } from '@/lib/admin-action-error';
import { adminsApi } from '@/lib/api';

/**
 * Resend an invitation (POST /admins/invitations/:id/resend). A resend revives
 * the invite to a fresh window — flipping an Expired row back to Pending. On
 * success, and on a 404/409 that means it changed under us, we refetch the
 * roster rather than patching the cache, so the row reflects server truth and
 * the remaining-slots indicator re-derives (TDEV-140).
 */
export function useResendInvitation() {
  const queryClient = useQueryClient();
  const refreshRoster = () =>
    void queryClient.invalidateQueries({ queryKey: queryKeys.admins.roster });
  return useMutation<{ id: string; expiresAt: string }, Error, string>({
    mutationFn: (invitationId) => adminsApi.resendInvitation(invitationId),
    onSuccess: refreshRoster,
    onError: (error) => {
      if (isAlreadyChangedError(error)) refreshRoster();
    },
  });
}
